import { IComponent } from "@faire/web-api/indigofair/data/IComponent";
import { IComponentLoggingData } from "@faire/web-api/indigofair/data/IComponentLoggingData";
import { ILayout } from "@faire/web-api/indigofair/data/ILayout";
import { ISection } from "@faire/web-api/indigofair/data/ISection";
import { ISectionLoggingData } from "@faire/web-api/indigofair/data/ISectionLoggingData";
import { IViewLoggingData } from "@faire/web-api/indigofair/data/IViewLoggingData";
import React from "react";

import {
  ComponentRenderMap,
  SDUIUPLTProps,
} from "@faire/retailer/components/SDUI/types";

export interface SDUIComponentRenderBehaviour {
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/loading
  imagesLoadingStrategy?: HTMLImageElement["loading"];
  /* Fetch Priority is not yet supported in all browsers, and React 19 and
    Styled Components 6 to use it.
    https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/fetchPriority
    While this property is not being used, it is being kept around as a comment to show
    how other rendering hints can be provided to the SDUIComponentRenderer
  */
  // imagesfetchPriority: HTMLImageElement["fetchPriority"];
  deferInitializationUntilView?: boolean;
}
export interface SDUIComponentInstanceRendererProps {
  component: IComponent;
  loggingData: ComponentLoggingEventParams;
  renderBehaviour?: SDUIComponentRenderBehaviour;
}

export interface SDUISectionInstanceRendererProps {
  section: ISection;
  componentRenderers: ComponentRenderMap;
  sectionLoggingData: SectionLoggingEventParams;
  loadTimingRef?: React.RefCallback<HTMLElement>;
  // performance related props. Existence to be re-evaluated after SD UI supports lazy loading
  shouldRenderBelowTheFold?: boolean;
  UPLTprops?: SDUIUPLTProps;
}

export type SectionLoggingEventParams = IViewLoggingData & ISectionLoggingData;
export namespace SectionLoggingEventParams {
  export const build = (
    partial?: Partial<SectionLoggingEventParams>
  ): SectionLoggingEventParams => {
    return {
      ...IViewLoggingData.build(partial),
      ...ISectionLoggingData.build(partial),
    };
  };
}

export type ComponentLoggingEventParams = SectionLoggingEventParams &
  IComponentLoggingData & { component_id: string | undefined };
export namespace ComponentLoggingEventParams {
  export const build = (
    partial?: Partial<ComponentLoggingEventParams>
  ): ComponentLoggingEventParams => {
    return {
      ...SectionLoggingEventParams.build(partial),
      ...IComponentLoggingData.build(partial),
      component_id: partial?.component_id,
    };
  };
}
export type ActionLoggingEventParams = ComponentLoggingEventParams & {
  action_content: string | undefined;
  action_positions: string | undefined;
  action_instance_identifier: string | undefined;
};
export namespace ActionLoggingEventParams {
  export const build = (
    partial?: Partial<ActionLoggingEventParams>
  ): ActionLoggingEventParams => {
    return {
      ...ComponentLoggingEventParams.build(partial),
      action_content: partial?.action_content,
      action_positions: partial?.action_positions,
      action_instance_identifier: partial?.action_instance_identifier,
    };
  };
}

export type LoggingEventParams =
  | SectionLoggingEventParams
  | ComponentLoggingEventParams
  | ActionLoggingEventParams;

export interface SDUILayoutRendererProps {
  components: Array<React.ReactNode>;
  componentKeys?: Array<string>;
  layout: ILayout | undefined;
}
